import { render } from "./SaleShow.vue?vue&type=template&id=08fa9ccc&scoped=true"
import script from "./SaleShow.vue?vue&type=script&lang=js"
export * from "./SaleShow.vue?vue&type=script&lang=js"

import "./SaleShow.vue?vue&type=style&index=0&id=08fa9ccc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08fa9ccc"]])

export default __exports__